// extracted by mini-css-extract-plugin
module.exports = {"news-list":"InfoColumn_news-list__3ZaYj"};